<template>
    <li class="options__item corp-orange">
        <router-link :to="{ name: to }" class="d-flex align-items-center justify-content-start options__link--primary">
            <i v-if="!!icon && icon.length" :class="itemClass"></i>
            <span> {{ label }}</span>
        </router-link>
    </li>
</template>
<script>
    export default {
        props: {
            to: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false
            }
        },
        computed: {
            itemClass: function(){
                if(!!this.icon && this.icon.length){
                    return `options-menu__icon fa fa-x2 ${this.icon}`;
                }else{
                    return 'options-menu__icon';
                }
            }
        }
    }
</script>